import { BackgroundContainer } from "@components/fullScreenVideo/background-container";
import VideosSlider from "./videos-slider";
import { type Post } from "./video-slide";

type ExperiencesSliderProps = {
  experienceId: number;
  title: string;
  posts: Post[];
  children: React.ReactNode;
  onClose: () => void;
  section: string;
  isSingleActivity: boolean;
  backgroundImage?: string;
};

export default function ExperiencesSlider({
  experienceId,
  title,
  posts,
  children,
  onClose,
  section,
  isSingleActivity,
  backgroundImage,
}: ExperiencesSliderProps) {
  return (
    <BackgroundContainer
      title={title}
      onClose={onClose}
      backgroundImage={backgroundImage}
    >
      <VideosSlider
        experienceId={experienceId}
        title={title}
        posts={posts}
        section={section}
        isSingleActivity={isSingleActivity}
      />

      {children}
    </BackgroundContainer>
  );
}
